module.exports = __webpack_public_path__ + "img/relogio.61401959.png";